"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _immutable = require("immutable");
var _TransmuteCollection = require("./TransmuteCollection");
_TransmuteCollection.forEach.implement(Array, (effect, arr) => arr.forEach(effect));
_TransmuteCollection.forEach.implementInherited(_immutable.Iterable, (effect, subject) => subject.forEach(effect));
_TransmuteCollection.forEach.implement(Object, (effect, obj) => {
  const keys = Object.keys(obj);
  const len = keys.length;
  for (let i = 0; i < len; i++) {
    const key = keys[i];
    effect(obj[key], key, obj);
  }
  return obj;
});
var _default = exports.default = _TransmuteCollection.forEach;
module.exports = exports.default;